import {
	isRegionScope,
	resolveWeiShopApi
} from "../utils/regionApiMap";
import {
	eltips
} from "@/util/util.js";

export function readRegionContext() {
	const raw = sessionStorage.getItem("regionContext");
	if (!raw) {
		return {};
	}
	try {
		return JSON.parse(raw) || {};
	} catch (e) {
		return {};
	}
}

export function writeRegionContext(context) {
	sessionStorage.setItem("regionContext", JSON.stringify(context || {}));
	return context || {};
}

export function getManagedRegionStores(context) {
	const data = context || readRegionContext();
	return data.stores || data.managed_stores || data.managedStores || [];
}

export function getCurrentRegionStoreId() {
	return sessionStorage.getItem("currentRegionStoreId") || "";
}

export function setCurrentRegionStoreId(storeId) {
	const value = storeId === "" || storeId == null ? "" : String(storeId);
	sessionStorage.setItem("currentRegionStoreId", value);
	return value;
}

export function appendCurrentRegionStore(params) {
	const payload = Object.assign({}, params || {});
	const storeId = getCurrentRegionStoreId();
	if (storeId) {
		payload.store_id = storeId;
	}
	return payload;
}

export function normalizeCurrentRegionStore(context, allowAll = false) {
	const stores = getManagedRegionStores(context);
	const visibleStoreIds = stores.map((store) => String(store.id));
	let storeId = allowAll ? "" : (getCurrentRegionStoreId() || (context || {}).default_store_id || "");
	storeId = storeId === "" || storeId == null ? "" : String(storeId);
	if (storeId && visibleStoreIds.indexOf(storeId) === -1) {
		storeId = "";
	}
	if (!storeId && !allowAll && stores.length > 0) {
		storeId = String(stores[0].id);
	}
	return setCurrentRegionStoreId(storeId);
}

export function getRegionApiErrorMessage(error, fallback) {
	const data = error && error.response && error.response.data ? error.response.data : {};
	return data.msg || data.message || (error && error.message) || fallback || "操作失败，请稍后重试";
}

export default {
	computed: {
		isRegionAccount() {
			return isRegionScope();
		},
		regionContext() {
			return readRegionContext();
		},
		managedRegionStores() {
			return getManagedRegionStores(this.regionContext);
		},
		currentRegionStoreId() {
			return getCurrentRegionStoreId();
		},
	},
	methods: {
		resolveWeiShopApi,
		readRegionContext,
		writeRegionContext,
		getManagedRegionStores,
		getCurrentRegionStoreId,
		setCurrentRegionStoreId,
		appendCurrentRegionStore,
		withRegionStoreParams(params) {
			return appendCurrentRegionStore(params);
		},
		getRegionApiErrorMessage,
		showRegionApiError(error, fallback) {
			eltips(getRegionApiErrorMessage(error, fallback), "error");
		},
		normalizeCurrentRegionStore,
		loadRegionContext() {
			if (!this.isRegionAccount) {
				return Promise.resolve(readRegionContext());
			}
			return this.axios.get("/api/weishop/region/context").then((res) => {
				if (res.code == 200) {
					const context = writeRegionContext(res.data || {});
					normalizeCurrentRegionStore(context);
					return context;
				}
				return Promise.reject(res);
			});
		},
	},
};
